import { Fragment } from 'react';

import { ThumbnailBtn } from '@playbooks/components/thumbnail/thumbnail-btn';
import { DescriptionFormGroup } from '@playbooks/molecules/form-groups';
import { Field, FieldLabel } from '@playbooks/ui/components/field';
import { Input } from '@playbooks/ui/components/input';

const ProjectAbbreviatedFields = ({ project, setProject }) => {
	return (
		<Fragment>
			<Field>
				<ThumbnailBtn
					title='Thumbnail'
					value={project.thumbnail}
					onChange={thumbnail => setProject({ ...project, thumbnail })}
				/>
			</Field>
			<Field>
				<FieldLabel>Name</FieldLabel>
				<Input
					required
					value={project.name || ''}
					onChange={event => setProject({ ...project, name: event.target.value })}
				/>
			</Field>
			<DescriptionFormGroup
				type='project'
				value={project}
				setValue={description => setProject({ ...project, description })}
			/>
		</Fragment>
	);
};

export { ProjectAbbreviatedFields };
